import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';
import { sum } from 'lodash';

// NOTE: set explicitly to match the date filter calendar
const CONTAINER_WIDTH = px(
    sum([
        // date filter calendar
        196,
        // date filter calendar margin
        12,
        // filter popover padding
        8,
    ])
);

export const useStyles = makeStyles({
    menuItem: {
        padding: tokens.spacingHorizontalXS,
    },
    filterContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingHorizontalXS,
        width: CONTAINER_WIDTH,
    },
});
